import { Repository } from '../repository';
import { type AssetType } from './entity';

export class AssetTypes extends Repository<AssetType> {
    private readonly prefix = 'CA';

    getByLabel(label: string): AssetType | undefined {
        return this.items.find((assetType) => assetType.label === label);
    }

    getNextLabel(): string {
        const customItems = this.items.filter(
            (assetType) => assetType.isCustom,
        );
        const lastCustomItem = customItems[customItems.length - 1];
        if (!lastCustomItem) {
            return `${this.prefix}00001`;
        }
        const nr = parseInt(lastCustomItem.label.slice(this.prefix.length));
        const newNr = nr + 1;
        return `${this.prefix}${newNr.toString().padStart(5, '0')}`;
    }
}
